import { DOMAIN } from '../../configurations/defaultConfigs';
import { IPhotoGallery } from '../Components/photogallery/photogallery.model';
import { ITestimonial } from '../Components/testimonial/testimonial.model';
import {
  DOMAIN_TYPE,
  LANGUAGE,
  ILANGUAGE,
  SCHEMA_TYPE,
  NATIONAL_PAGES,
} from '../constants';
import { ATTACHMENT_TYPES, IAttachment } from '../Models/attachment.model';
import { IResponse } from '../Models/response.model';
import { ISchoolArticle } from '../Models/schoolArticle.model';
import { SchoolApiService } from '../Services/schoolApi.service';
import { Utils } from '../utils';

export abstract class BaseComponent {
  public domainType: DOMAIN_TYPE;
  public schemaType: SCHEMA_TYPE;
  public articleType: string;
  public language: ILANGUAGE;
  public contactFormFields: any = {
    name: '',
    email: '',
    subject: '',
    message: '',
  };

  constructor(readonly schoolApiService: SchoolApiService) {
    this.language =
      (localStorage.getItem('language') as unknown as ILANGUAGE) ??
      LANGUAGE.FRENCH;
  }

  public mapArticles(articles: ISchoolArticle[]) {
    return (
      articles.map((article) => {
        return {
          ...article,
          ...this.mapArticleAttachements(article),
        };
      }) || []
    );
  }

  public mapArticleAttachements(article: ISchoolArticle): {
    images: string[];
    videos: string[];
    pdfs: IAttachment[];
  } {
    const images =
      article.attachments.filter(
        (file) => file.type == ATTACHMENT_TYPES.IMAGE
      ) || [];
    const videos =
      article.attachments.filter(
        (file) => file.type == ATTACHMENT_TYPES.VIDEO
      ) || [];
    const pdfs =
      article.attachments.filter((file) => file.type == ATTACHMENT_TYPES.PDF) ||
      [];
    return {
      images: images.map((image) => Utils.mapBase64Image(image.content)),
      videos: videos.map((video) => video.content),
      pdfs: pdfs,
    };
  }

  public mapPhotoGallery(articles: ISchoolArticle[]): IPhotoGallery[] {
    const gallery: IPhotoGallery[] = [];
    articles.forEach((article) => {
      const images = this.mapArticleAttachements(article).images;
      images.forEach((image) =>
        gallery.push({
          title: article.title[this.language],
          content: image,
        })
      );
    });
    return gallery;
  }

  public splitYoutubeIdFromURL(url: string): string {
    if (!url?.length) return '';
    return url.includes('watch?v=')
      ? url.split('watch?v=')[1]
      : url.split('/')[url.split('/').length - 1];
  }

  public mapTestimonials(articles: ISchoolArticle[]): ITestimonial[] {
    return articles?.length
      ? articles.map((item) => {
          return {
            title: item.title[this.language],
            profession: item.profession ? item.profession[this.language] : null,
            description: item.description[this.language],
            image: item.attachments.length
              ? Utils.mapBase64Image(item.attachments[0].content)
              : null,
            videoLink: item.links?.length
              ? this.splitYoutubeIdFromURL(item.links[0])
              : null,
          };
        })
      : [];
  }

  onContactFormFieldChange(field: string, event: any) {
    this.contactFormFields[field] = event.target.value;
  }

  submitContactForm() {
    this.schoolApiService
      .emailSubscribe({
        domainType: DOMAIN,
        schemaType: SCHEMA_TYPE.EMAIL,
        articleType: NATIONAL_PAGES.EMAIL.CONTACT_US,
        ...this.contactFormFields,
      })
      .subscribe((data: IResponse<Boolean>) => {
        Object.keys(this.contactFormFields).forEach((key) => {
          this.contactFormFields[key] = '';
        });
      });
  }

  public getLibraryStyleImage() {
    return this.language === 'ar'
      ? 'float: left; margin-right: 15px'
      : 'float: right; margin-left: 15px';
  }

  public isValidEmail(email: string): boolean {
    // Regular expression for validating an email address
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailPattern.test(email);
  }

  public getShortDescription(description: string, maxChars?: number): string {
    const maxLength = maxChars || 100;
    return description.length > maxLength
      ? description.substring(0, maxLength) + '...'
      : description;
  }
}
